export class TWHandleErrors {
  file: null | File | FileList;

  constructor(
    public $form: HTMLFormElement = null,
    public $dropArea: HTMLElement = null,
    public $tracker: HTMLElement = null
  ) {}

  handleDisabledInputs(inputsAreDisabled?: boolean) {
    if (this.$form) {
      const $inputs = this.$form.querySelectorAll("input");
      const $select = this.$form.querySelector("select");
      const $textArea = this.$form.querySelector(
        "#note-aggiuntive"
      ) as HTMLTextAreaElement;
      const $disabledSections =
        this.$form.querySelectorAll(".tw-input-section");
      const $addToCartButton = this.$tracker.querySelector(
        ".tw-print-cart-button"
      ) as HTMLButtonElement;
      const $finalPrice = this.$tracker.querySelector(".final-price");

      $inputs.forEach((e) => {
        if (
          e.name !== "tw-form-upload" &&
          !e.classList.contains("--forcefully-disabled")
        ) {
          e.disabled = inputsAreDisabled;
        }
      });
      $select.disabled = inputsAreDisabled;
      $textArea.disabled = inputsAreDisabled;
      $disabledSections.forEach((e) =>
        e.classList[inputsAreDisabled ? "add" : "remove"]("disabled")
      );
      $addToCartButton.disabled = inputsAreDisabled;
      inputsAreDisabled && ($finalPrice.innerHTML = "-");

      // Hides the tracker and active droparea in case of error
      // this.$tracker.classList[fileIsUploaded ? "add" : "remove"](
      //   "--file-uploaded"
      // );
      // this.$dropArea.classList[fileIsUploaded ? "add" : "remove"](
      //   "--file-uploaded"
      // );
    }
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const $form = document.querySelector("#tw-print-form") as HTMLFormElement;
  // const $dropArea = document.querySelector(".tw-file-drop-area") as HTMLElement;
  // const $tracker = document.querySelector("#tw_form_tracker") as HTMLElement;
  new TWHandleErrors($form);
});
